
const EnvName={
    dev:"dev",
    test:"test",
    prod:"prod",
  }
  
const ProdHostName='www.medcircle.cn';
const ApiSocketPort=13771;
const ChatSocktPort=8093;
const AppNameCN='爱德华直播'
  function getEnvName()
  {
    const hostname = location.hostname;
    let weixin = {
      appId: null
    };
    
    // 生产环境
     if (hostname == ProdHostName) {
      return EnvName.prod
    }
    else {
      return EnvName.dev;
    }
  }
  
  function getWeixin() {
    var env=getEnvName();
    let weixin = {
      appId: null,
      server: null
    };
     // 测试
    if (env==EnvName.dev || env==EnvName.test) {
      weixin.appId = "wxc94beeaf4f4c9d5e"; // 微信开放平台: hepengzhan@medcircle.cn : 医点通技术支持 公众号服务号: wxc94beeaf4f4c9d5e
    } 
    // 生产环境
    else if (env==EnvName.prod) {
      weixin.appId = "wx28894f112b1418e7"; // 
    }
    weixin.server="/edwardsAPI/api";
    return weixin;
  }
  
  function getSocketPort() {
    const hostname = location.hostname;
    if (window.location.protocol === 'https:') {
      return 'https://cmdhra.medcircle.cn/'
    } else {
      return 'http://123.57.233.107:8093/';  // 
    }
  }

  function getNettyUrl() {
    var hostName= window.location.hostname;
    return `ws://${hostName}:${ApiSocketPort}/ws`;
  }
  
  // import AppSetting from '@/AppSetting'
  export default {
    appNameEN: "RA",
    appNameCN: 'RA直播',
    RouterBase: "cmdhra_tpl", 
    baseUrl: "/ra-app/api",
    getWeixin,
    getSocketPort,
    getNettyUrl,
  };
  


// WEBPACK FOOTER //
// ./src/AppSetting.js